const state = {
  active: false
}

export default state
